import React from 'react';
import './Unlisted.css';
import { AiFillLock } from "react-icons/ai";
const Lock = AiFillLock as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

const Unlisted: React.FC = () => {

  return (
    <div className="not-cslisted">
        <Lock />
        <div>Project not listed yet</div>
        <a className='list-text' href='/list'>
          List now for free
        </a>
    </div>
  );
};

export default Unlisted;
